export const fonts = {
	mono: 'Source Code Pro',
};
